import Navbar from "../components/Navbar"
import KeyFeatures from "../components/KeyFeatures"
import Benefits from "../components/Benefits"
import UseCasesSection from "../components/UseCasesSection"
import FaqSection from "../components/FaqSection"
import GetStartedCard from "../components/GetStartedCard"
import GetInTouch from "../components/GetInTouch"
import Footer from "../components/Footer"
import heroBg from "../assets/hero-bg.png"
import petrolImg from "../assets/Tailored Solutions.jpg"
import reduceOperationalCostsImg from "../assets/Reduce Operational Costs.jpg"
import enhanceDriverSafetyImg from "../assets/Enhance Driver Safety.jpg"
import boostFleetProductivityImg from "../assets/Boost Fleet Productivity.jpg"
import improveCustomerExperienceImg from "../assets/Improve Customer Experience.jpg"
import ensureRegulatoryComplianceImg from "../assets/Ensure Regulatory Compliance.jpg"
import useCaseLogisticsImg from "../assets/Vehicle-Tracking.jpg"
import useCaseConstructionImg from "../assets/truck1.webp"
import useCaseFieldServicesImg from "../assets/tracksmart.jpg"
import useCaseHealthcareImg from "../assets/truck3.webp"
import homeVehicletrackingImg from "../assets/homeVehicletracking.png"
import scalableImg from "../assets/scalable.webp"

const videoFeatures = [
  {
    title: "Real-Time GPS Tracking",
    desc: "Monitor vehicle locations continuously with precise GPS technology, allowing you to track your entire fleet from a single dashboard.",
  },
  {
    title: "Geofencing",
    desc: "Set virtual boundaries and receive alerts on breaches, helping you maintain control over vehicle movements and prevent unauthorized use.",
  },
  {
    title: "Driver Behavior Analysis",
    desc: "Assess driving patterns for safety improvements by monitoring speeding, harsh braking, and rapid acceleration to enhance driver safety.",
  },
  {
    title: "Maintenance Alerts",
    desc: "Schedule timely vehicle servicing with automated maintenance reminders based on mileage, engine hours, or calendar intervals.",
  },
  {
    title: "Customizable Reports",
    desc: "Generate reports tailored to your business needs, providing valuable insights into fleet performance, utilization, and efficiency.",
  },
  {
    title: "Mobile Access",
    desc: "Manage your fleet from anywhere using our mobile app, giving you the flexibility to monitor operations on the go.",
  },
]

const benefits = [
  {
    number: "01",
    title: "Reduce Operational Costs",
    desc: "Fuel efficiency helps optimize routes and reduce idling time to lower fuel consumption. Maintenance management gives timely service alerts to prevent costly repairs, while operational efficiency helps monitor driver behavior to reduce wear and tear on vehicles.",
    image: reduceOperationalCostsImg,
    imageAlt: "Reduce Operational Costs",
  },
  {
    number: "02",
    title: "Enhance Driver Safety",
    desc: "Behavior monitoring tracks speeding, harsh braking, and rapid acceleration. Real-time alerts notify you about unsafe driving practices, while training insights help improve driver performance with targeted safety programs.",
    image: enhanceDriverSafetyImg,
    imageAlt: "Enhance Driver Safety",
  },
  {
    number: "03",
    title: "Boost Fleet Productivity",
    desc: "Route optimization helps determine the most efficient routes to save time. Dispatch efficiency assigns tasks based on real-time vehicle locations, while utilization reports help maximize asset deployment.",
    image: boostFleetProductivityImg,
    imageAlt: "Boost Fleet Productivity",
  },
  {
    number: "04",
    title: "Improve Customer Experience",
    desc: "Accurate ETAs provide customers with precise delivery times. Real-time tracking allows customers to monitor deliveries live, while responsive service helps quickly address delays or issues with proactive communication.",
    image: improveCustomerExperienceImg,
    imageAlt: "Improve Customer Experience",
  },
  {
    number: "05",
    title: "Ensure Regulatory Compliance",
    desc: "Electronic logging helps maintain accurate records of driver hours and vehicle usage. Regulatory reporting generates legal reports effortlessly, while audit preparedness keeps records organized for smooth audits.",
    image: ensureRegulatoryComplianceImg,
    imageAlt: "Ensure Regulatory Compliance",
  },
]

const useCases = [
  {
    number: "01",
    title: "Logistics & Transportation",
    desc: "Ensure timely deliveries, improve route efficiency, and monitor fleet movement with real-time vehicle tracking and location visibility.",
    variant: "side",
    image: useCaseLogisticsImg,
  },
  {
    number: "02",
    title: "Construction",
    desc: "Monitor equipment usage, track site vehicles, prevent unauthorized use, and optimize asset allocation across construction projects.",
    variant: "center",
    image: homeVehicletrackingImg,
  },
  {
    number: "03",
    title: "Field Services",
    desc: "Optimize technician dispatch, monitor service calls, reduce response times, and improve customer satisfaction with live fleet visibility.",
    variant: "side",
    image: useCaseFieldServicesImg,
  },
  {
    number: "04",
    title: "Healthcare",
    desc: "Track medical transport, ambulance movement, and emergency service vehicles to improve response time and patient safety.",
    variant: "side",
    image: scalableImg,
  },
]


const faqs = [
  {
    question: "How does the vehicle tracking system work?",
    answer:
      "Our system uses GPS technology to provide real-time location data, which is accessible via our web and mobile platforms. The tracking devices installed in your vehicles continuously transmit location and performance data to our secure servers, allowing you to monitor your fleet in real-time.",
  },
  {
    question: "Is the system compatible with all vehicle types?",
    answer:
      "Yes, our tracking devices are compatible with a wide range of vehicles, including cars, trucks, and specialized equipment. Our hardware is designed to work with various vehicle makes and models, ensuring comprehensive coverage for your entire fleet.",
  },
  {
    question: "Can I access the tracking information remotely?",
    answer:
      "Absolutely. Our platform is cloud-based, allowing you to monitor your fleet from anywhere at any time. You can access all tracking information through our web portal or mobile app, giving you complete flexibility in managing your fleet operations.",
  },
  {
    question: "How does the system help with compliance?",
    answer:
      "It automates record-keeping for driver hours and vehicle usage, ensuring adherence to industry regulations. Our system maintains detailed logs of all vehicle activities, which can be easily accessed and exported for compliance reporting and audits.",
  },
  {
    question: "What kind of reports can I generate with the system?",
    answer:
      "Our system offers a wide range of customizable reports, including driver behavior, vehicle utilization, fuel consumption, maintenance schedules, and route efficiency. These reports can be automated, scheduled, and exported in various formats to meet your specific business needs.",
  },
]

export default function Section8() {
  const containerClass =
    "mx-auto w-full max-w-[1600px] px-5 sm:px-8 lg:px-12 xl:px-20"

  return (
    <>
      {/* Hero */}
      <section className="relative mx-auto w-full max-w-[calc(100%-24px)] overflow-hidden rounded-b-[42px] bg-black sm:max-w-[calc(100%-32px)] lg:max-w-[calc(100%-48px)]">
        <Navbar />

        <div
          className="relative min-h-[560px] bg-cover bg-center sm:min-h-[620px] lg:min-h-[700px]"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="absolute inset-0 bg-black/68" />

          <div className="relative z-10 flex min-h-[560px] items-center justify-center px-5 pt-24 text-center sm:min-h-[620px] lg:min-h-[700px]">
            <div className="mx-auto max-w-[920px]">
              <h1 className="text-[34px] font-bold leading-tight text-white sm:text-5xl lg:text-[60px]">
                Optimize Your Fleet with Advanced <br className="hidden sm:block" />
                Vehicle Tracking

              </h1>

              <div className="mx-auto mt-3 h-[3px] w-[240px] rounded-full bg-[#ed860f] sm:w-[420px] lg:w-[520px]" />

              <p className="mx-auto mt-7 max-w-[760px] text-sm leading-relaxed text-white/75 sm:text-base">
                Real-time GPS tracking, driver behavior monitoring, and intelligent video solutions for a more efficient and safer fleet.
              </p>

              <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
                <a
                  href="#about-ais140"
                  className="inline-flex min-w-[210px] items-center justify-center rounded-md bg-[#ed860f] px-8 py-4 text-sm font-medium text-white transition hover:bg-[#d9780d]"
                >
                  Explore Solutions
                </a>

                <a
                  href="/contact"
                  className="inline-flex min-w-[210px] items-center justify-center rounded-md border border-white px-8 py-4 text-sm font-medium text-white transition hover:bg-white hover:text-black"
                >
                  Request demo
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section
        id="about-ais140"
         className="bg-white py-14 sm:py-16 lg:py-20">
        <div className={`${containerClass} grid gap-10 lg:grid-cols-2 lg:items-center lg:gap-16`}>
          <div>
            <h2 className="text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-[42px]">
              Vehicle Tracking Built for Your Business
            </h2>

            <p className="mt-3 text-sm font-semibold leading-relaxed text-gray-600 sm:text-[15px]">
              Our comprehensive solution helps businesses with live vehicle tracking, fleet operations, and data-driven control.
            </p>

            <h3 className="mt-8 text-xl font-bold text-black">
              Tailored Solutions for Every Business
            </h3>

            <p className="mt-4 max-w-[720px] text-sm leading-relaxed text-gray-600 sm:text-[15px]">
              Our system offers robust analytics and reporting tools, allowing you to generate daily, weekly, and fully customized reports. You can monitor real-time vehicle fuel consumption with precision and gain deeper insights into operational efficiency across all records.
            </p>

            <p className="mt-4 max-w-[720px] text-sm leading-relaxed text-gray-600 sm:text-[15px]">
              Real-time alerts notify you instantly in cases of fuel theft, unauthorized disconnections, route deviation, harsh stops, poor eco-based access, and mobile web compatibility, managers can track operations remotely, while smart reports and a complete audit trail ensure full transparency and accountability.
            </p>

            <a
              href="/services"
              className="mt-7 inline-flex items-center justify-center rounded-md bg-[#ed860f] px-8 py-3 text-sm font-medium text-white transition hover:bg-[#d9780d]"
            >
              Discover Features
            </a>
          </div>

          <div className="overflow-hidden rounded-xl lg:justify-self-end">
            <img
              src={petrolImg}
              alt="Vehicle tracking solution"
              className="h-[270px] w-full object-cover sm:h-[360px] lg:h-[430px] lg:max-w-[620px]"
            />
          </div>
        </div>
      </section>

      <KeyFeatures features={videoFeatures} />

      <Benefits
        title="Key Benefits"
        desc="Discover how our vehicle tracking system can transform your fleet operations."
        items={benefits}
      />

      <UseCasesSection items={useCases} />

      <FaqSection
        title="Frequently Asked Questions"
        desc="Find answers to common questions about our vehicle tracking system."
        faqs={faqs}
      />

      <section className="bg-white py-10 sm:py-12 lg:py-16">
        <div className={containerClass}>
          <GetStartedCard
            title="Get Started in Minutes"
            desc="Experience the power of automation with FleetRobo® AIS-140 ICAT Certified Devices"
            primaryText="Explore Solutions"
            secondaryText="Contact us"
            primaryHref="/services"
            secondaryHref="/contact"
          />
        </div>
      </section>

      <Footer />
    </>
  )
}
